import * as React from "react";
const SvgFiRrVirusSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-virus-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-.885-.885a2.5 2.5 0 0 0-.557-2.675 2.5 2.5 0 0 0-2.675-.557l-1.275-1.275a8 8 0 0 0 1.121-1.958l2.19.55q.124.03.244.03a1 1 0 0 0 .242-1.97l-2.187-.549a8 8 0 0 0 .004-1.982l2.183-.547a1 1 0 0 0-.486-1.94l-2.182.547A8 8 0 0 0 18.315 7.1l1.276-1.276c.283.111.588.177.91.177a2.5 2.5 0 1 0-2.5-2.5c0 .322.066.627.177.91l-1.276 1.275a8 8 0 0 0-2.118-1.177l.565-2.252a.999.999 0 1 0-1.939-.486l-.572 2.28a8 8 0 0 0-1.925.037l-.58-2.317a1 1 0 0 0-1.94.486l.586 2.338a8 8 0 0 0-1.877 1.091L5.83 4.412a2.498 2.498 0 0 0-3.24-3.24l-.88-.88A1 1 0 0 0 .293.293a1 1 0 0 0 0 1.414l6.05 6.05 9.897 9.897v.001l6.05 6.05a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.415zM16.243 7.758c2.097 2.098 2.3 5.365.636 7.706L8.536 7.122c2.341-1.663 5.61-1.462 7.707.636M9.5 16.001a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1 0 3m6.5-6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-.652 12.27a1 1 0 1 1-1.94.486l-.576-2.298a8 8 0 0 1-1.917-.036l-.586 2.334a1 1 0 0 1-1.94-.486l.595-2.369a8 8 0 0 1-1.888-1.084l-1.273 1.273c.11.282.176.586.176.907a2.5 2.5 0 0 1-2.5 2.497A2.5 2.5 0 0 1 1 20.498a2.5 2.5 0 0 1 2.5-2.497c.322 0 .627.066.91.176l1.272-1.273a8 8 0 0 1-1.14-2.02l-2.43.608a1 1 0 0 1-.486-1.94l2.426-.609a8 8 0 0 1 0-1.872l-2.422-.597a1 1 0 0 1-.73-1.21.995.995 0 0 1 1.21-.73l3.332.82a1 1 0 0 1 .732 1.21 5.96 5.96 0 0 0 1.584 5.678 5.98 5.98 0 0 0 5.596 1.604 1 1 0 0 1 1.195.731l.8 3.192z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-virus-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVirusSlash;
